import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveReportPage } from '@/features/leaveReport/pages/LeaveReportPage';
import { leaveReportSearchSchema } from '@/features/leaveReport/types/leaveReport.types';

export const Route = createFileRoute('/_auth/hr-form/leave-report')({
  validateSearch: leaveReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Leave Report">
      <Suspense fallback={<PageLoader />}>
        <LeaveReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
